/**
 * Covers a dialog while a save runs several API calls in a row, so nothing can be clicked or closed until every call
 * has finished. Place it inside the dialog's Paper (the Dialog's PaperProps need position: relative).
 */

import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const SavingOverlay = ({ open, label = 'Saving — please wait…' }) => {
  if (!open) return null;
  return (
    <Box sx={{
      position: 'absolute', inset: 0, zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 1.5, cursor: 'wait',
      bgcolor: (t) => (t.palette.mode === 'dark' ? 'rgba(0,0,0,0.55)' : 'rgba(255,255,255,0.7)'),
    }}>
      <CircularProgress size={32} />
      <Typography variant="body2" fontWeight={600}>{label}</Typography>
    </Box>
  );
};

export default SavingOverlay;
